import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Typography, SpinnerLoader, EnumSpinnerLoaderPosition, Button } from 'shared/ui'
import { Table } from 'shared/ui/TableNew'
import { DeveloperEmptyState } from 'pages/settings/pages/developer/ui/DeveloperEmptyState/DeveloperEmptyState'
import { useAccessTokensViewContext } from 'pages/settings/pages/developer/pages/accessTokens/context/accessTokensViewContext'
import { accessTokensTableColumns } from 'pages/settings/pages/developer/pages/accessTokens/ui/AccessTokensTable/accessTokensTableColumns'
import { getAccessTokensTableActions } from 'pages/settings/pages/developer/pages/accessTokens/ui/AccessTokensTable/getAccessTokensTableActions'
import { DeveloperDocsSelect } from 'pages/settings/pages/developer/ui/DeveloperDocsSelect/DeveloperDocsSelect'
import styles from './styles.module.scss'

export const AccessTokensPage = observer(() => {
  const store = useAccessTokensViewContext()
  const hasNoTokens = !store.loading && store.tokens.length === 0

  const rows = useMemo(() => {
    return store.items.map((item) => {
      item.setActionsProps({
        actions: getAccessTokensTableActions(item, store),
        showItems: 1,
        noVisibleActions: false,
        iconButtonProps: {
          size: 'small',
          ariaLabel: 'TableRow_actions',
          color: 'tertiary',
          fontSize: 16,
        },
      })
      item.setAriaLabel('PersonalAccessTokenRow')
      return item
    })
  }, [store.items, store])

  if (store.loading) {
    return (
      <div className={styles.loaderWrapper}>
        <SpinnerLoader
          ariaLabel={'AccessTokensPage'}
          position={EnumSpinnerLoaderPosition.Absolute}
          size={32}
        />
      </div>
    )
  }

  return (
    <div className={styles.content}>
      {hasNoTokens ? (
        <div className={styles.emptyWrapper}>
          <DeveloperEmptyState
            title='Create your first token'
            text='Generate a personal access token to authenticate API requests'
            primaryButtonText='New token'
            onPrimaryClick={store.openNewTokenModal}
            ariaLabel='Personal access tokens empty state'
          />
        </div>
      ) : (
        <>
          <div className={styles.header}>
            <div className={styles.headerLeft}>
              <Typography variant='heading-lg' ariaLabel='Personal Access Tokens title'>
                Personal Access Tokens
              </Typography>
              <Typography
                variant='body-md-regular'
                ariaLabel='Personal Access Tokens desc'
                color='var(--content-primary-tertiary)'
              >
                Manage personal tokens for direct API access
              </Typography>
            </div>
            <div className={styles.headerRight}>
              <DeveloperDocsSelect className={styles.headerAction} />
              <Button
                text='New token'
                size='medium'
                icon='add'
                onClick={store.openNewTokenModal}
                className={styles.headerAction}
              />
            </div>
          </div>

          <div className={styles.tokensContent}>
            <Table
              ariaLabel={'AccessTokensTable'}
              store={store.tableStore}
              columns={accessTokensTableColumns}
              rows={rows}
              loading={false}
              hidePagination
              defaultColumnCellStyle={{
                height: '45px',
                maxHeight: '45px',
                minHeight: '45px',
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: '4px',
                lineHeight: '45px',
              }}
            />
          </div>
        </>
      )}
    </div>
  )
})
